import Header from './layout/header.js';

document.addEventListener('DOMContentLoaded', async () => {
  Header.init();
});
